import React from "react";
import classes from "./transactionsMobile.module.css";
import {
  PaymentIconRed,
  UserIconRed,
  StarIconRed,
  WorkingHoursRed,
  Visa,
  TransactionRedIcon,
} from "../../../../constant/imagePath";
import { Container, Row, Col, Table } from "react-bootstrap";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { ReactSVG } from "react-svg";

export const TransactionsMobile = () => {
  const transactiondata = [
    {
      date: "11/13/19",
      title: "1 on 1 Tennis Lesson with John Johnson",
      cardNumber: 3679,
      price: 75,
      upcoming: true,
    },
    {
      date: "11/13/19",
      title: "1 on 1 Tennis Lesson with John Johnson",
      cardNumber: 3679,
      price: 80,
      upcoming: false,
    },
  ];
  return (
    <div>
      {transactiondata.length > 1 ? (
        <Table
          responsive
          bordered={false}
          striped={false}
          hover={false}
          className={[classes.transactionTable].join(" ")}
        >
          <thead>
            <tr>
              <th
                className={["p-0"].join(" ")}
                style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
              >
                Date
              </th>
              <th
                className={["p-0"].join(" ")}
                style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
              >
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            {transactiondata?.map((item, i) => {
              return (
                <tr
                  key={i}
                  style={{
                    borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                  }}
                >
                  <td className={["p-0", classes.py20].join(" ")}>
                    <span
                      style={{
                        ...Fonts.h7,
                        color: item.upcoming
                          ? Colors.neutralShadesOfPinkSwan
                          : Colors.neutralShadesOfNero,
                        lineHeight: "24px",
                      }}
                      className={[classes.mb4].join(" ")}
                    >
                      {item.date} {item.upcoming && <span>(Upcoming)</span>}
                    </span>
                  </td>
                  <td
                    className={["p-0", classes.py20].join(" ")}
                    style={{
                      ...Fonts.h6,
                      color: item.upcoming
                        ? Colors.neutralShadesOfPinkSwan
                        : Colors.neutralShadesOfNero,
                    }}
                  >
                    ${item.price}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <div className={[classes.noPayoutDiv].join(" ")}>
          <div style={{ width: "328px" }}>
            <ReactSVG
              src={TransactionRedIcon}
              className={[classes.upcomingPayouts, classes.mb16].join(" ")}
            />
            <h3
              className={[classes.textcenter, classes.mb8].join(" ")}
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
                fontSize: "24px",
                lineHeight: "32px",
              }}
            >
              You do not have any upcoming payouts
            </h3>
            <p
              className={[classes.textcenter].join(" ")}
              style={{
                ...Fonts.b1Mobile,
                color: Colors.neutralShadesOfDimGray,
                lineHeight: "24px",
              }}
            >
              Once a student has booked a lesson with you, transaction
              information will appear here.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
